var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEclipse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 226,
    viewBox: "0 0 235 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.31 83.1576C198.807 121.426 170.556 178.358 132.287 190.855C94.0179 203.351 49.2909 170.25 36.7945 131.981C24.298 93.7122 57.0587 41.8456 95.3275 29.3491C158.543 8.70663 173.814 44.8888 186.31 83.1576Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.374 152.36C233.374 172.158 224.704 187.12 211.503 197.16C198.274 207.221 180.46 212.36 162.215 212.36C143.945 212.36 124.679 207.893 109.268 197.469C93.8962 187.07 82.3099 170.712 79.3643 146.777C78.2488 120.395 89.834 99.691 106.272 85.5553C122.741 71.3926 144.046 63.8596 162.215 63.8596C198.359 63.8596 233.374 99.2609 233.374 152.36Z",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4451 43.5887C94.4631 29.8988 112.73 26.3047 129.559 29.6092C146.416 32.9191 161.9 43.1663 173.25 57.2752C184.618 71.4071 192.789 89.3882 193.457 108.499C194.125 127.571 187.325 147.856 168.607 166.679C124.692 204.863 68.5132 187.887 45.8726 159.743C23.412 131.822 31.8439 80.2722 77.4451 43.5887Z",
    stroke: "#E5E5E5",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipse);
export default __webpack_public_path__ + "static/media/eclipse.2c3273ffcf9487b197ac3dab8814a06b.svg";
export { ForwardRef as ReactComponent };